import styled from 'styled-components'

export const Container = styled.div`
  .change-password-info-section {
    background: #28c4d4;

    img {
      bottom: 0;
      position: absolute;
      width: 33%;
    }
  }
`
